import { PMCConfig } from '@kyruus/types';

import { persistBcsToken } from './cerner';
import { persistSignedPatientToken } from './signed-patient-token';

/**
 * Persists any third-party patient tokens found on the URL into localStorage, for every
 * integration: the cerner `bcs_token` and the signed patient token. Client-side route changes
 * (e.g. to /book) drop the query string, so this needs to run once when the app loads.
 * Safe to call server side, where it does nothing.
 */
export function persistThirdPartyTokens(
  config: PMCConfig | null | undefined
): void {
  // the bcs_token used to be forwarded on the /book URL; the scheduling MFE now reads it from localStorage
  persistBcsToken();
  // only persists when the customer has the signed patient token integration configured
  persistSignedPatientToken(config);
}
